import { render, staticRenderFns } from "./BannerArticles.vue?vue&type=template&id=706e31d1&scoped=true&"
import script from "./BannerArticles.vue?vue&type=script&lang=js&"
export * from "./BannerArticles.vue?vue&type=script&lang=js&"
import style0 from "./BannerArticles.vue?vue&type=style&index=0&id=706e31d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706e31d1",
  null
  
)

export default component.exports